<template>
    <div>
      <div class="top-filter-panel">
        <slot name="top"></slot>
      </div>
      <div class="filter-panel panel">
        <div class="title">Filtreleme Yapın</div>
        <div class="content">
            <form v-on:submit.prevent="onSubmit">
                <slot name="content"></slot>
                <div class="col">
                  <ButtonLoader class="primary" :loader="loader" :text="'Sonuçları Filtreleyin'" />
                </div>
            </form>
        </div>
      </div>
      <slot name="bottom"></slot>
    </div>
</template>

<script>
  export default{
    props: ['onSubmit', 'loader']
  }
</script>